import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import { useModalContext } from 'hooks/useModalContext';
import generatePath from '@utils/generatePath';
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';  
import { SCHOOL_PAGE} from 'constants/url';
import { history } from '@store/history';
import { qsParse } from '@utils/url-utils';
import styles from './styles.scss';

/**  处理数据 */
function splitList(list: any[], num: number) {
	const copyList = [...list];
	copyList.splice(num, copyList.length - 1);
	return copyList;
}
// const expandObj: any = {};

type IProps = {
	regId?: string;
	name?: string;
	mark?: string;
}

export default function ClassesSection(props: IProps){
	const { regId, name, mark } = qsParse();
	const { width } = useResizeObserver();
	const { t, local, list, transData } = useTranslation('home.classes');
	const { isShow, setHeader, setClassName, extraObject, setExtraObject } = useModalContext();
	const [showAll, setShowAll] = useState<boolean>(extraObject?.listAll?.length > 10);
	const classesRef = useRef<any>(null);
	const headerRef = useRef<any>(null);
	const tabRef = useRef<any>(null);
	const [isExpand, setExpand] = useState<boolean>(false);
	const [item, setItem] = useState<any>();
	if (item) {
		history.push({
			pathname: generatePath(SCHOOL_PAGE),
			search: `?title=${item.title}&regId=${regId}&name=${name}&mark=${mark}`,
		});
	}
	
	const renderItemIcon = useMemo(() => {
		return extraObject?.listAll?.map((item: { title: any; img: any }, index: React.Key | undefined) => {
			const { title, img } = item;
			return (
				<div className={styles['item-icon']} key={index} onClick={ () => setItem(item) }>
					<img src={img} alt="" loading="lazy" />
					<h3>{title}</h3>
				</div>
			);
		});
	}, [extraObject?.listAll]);

	// 设置弹窗数据
	useEffect(() => {
		if (showAll) {
			if (extraObject?.listAll?.length == list) return;
			setExtraObject({
				listAll: list,
			});
		} else {
			setExtraObject({
				listAll: width >= 768 && width < 1192 ? splitList(list, 24) : splitList(list, 24),
			});
		}
	}, [showAll, list, width]);

	// useEffect(() => {
	// 	if (!isShow && width < 768) {
	// 		expandObj.setExpand = setExpand;
	// 	}
	// }, [isShow, width]);

	return (
		<section className={styles['ac-section']}>
			{ width<1200 ? <div className={styles['ac-classes']}>
				<div className={styles['ac-header']}>
					<div className={styles['inner']}>
						<div className={styles['logo_container']}>
							<a href="/">  
								<img loading="lazy" className={styles['logo_icon']} src="https://web-data.zmlearn.com/image/rVhzGp9uKt6JnELQ2nwWQK/logo%402x.png" alt="air-class"/>
							</a>
						</div>
					</div>
				</div>
				<div className={styles['ac-classes-container']}>
					<h1>Which subject do you need help?</h1>
					<div className={styles['steps']}>
						<div className={styles['step1']}></div>
						<div className={styles['step2']}></div>
					</div>
					<div className={styles['ac-classes-list']}>{renderItemIcon}</div>
				</div>
			</div> : 
			<div className={styles['eeo-schoolAuthReg']}>
				<div className={styles['leftBox']}>
					<div className={styles['formBox']}>
						<div className={styles['leftContainer']}>
							<div className={styles['eeo-formBoxLogin']}>
								<div className={styles['ac-classes-container']}>
									<h1>Which subject do you need help?</h1>
									<div className={styles['steps']}>
										<div className={styles['step1']}></div>
										<div className={styles['step2']}></div>
									</div>
									<div className={styles['ac-classes-list']}>{renderItemIcon}</div>
								</div>
							</div>
						</div>
					</div>
					<div className={styles['rightImg']}></div>
					<div className={styles['header']}>
						<div className={styles['inner']}>
							<div className={styles['logo_container']}>
								<a href="/">  
									<img loading="lazy" className={styles['logo_icon']} src="https://web-data.zmlearn.com/image/rVhzGp9uKt6JnELQ2nwWQK/logo%402x.png" alt="air-class"/>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>}
		</section>
	);
}
